import { PartnerType } from "@/app/utils/partners.enum";
import { streamRequest, StreamOptions } from "../http/sseClient";

export interface CreateSimulationsRequest {
  cpf: string;
  isRefinancing: boolean;
  phone: string;
  type?: PartnerType.CREFISA | PartnerType.CREFISA_INSS;
  borrowedValue?: number;
  installmentValue?: number;
  codigoInstituicao?: string;
  codeReceiptDataId?: number;
  valorBeneficio?: number | "";
  possuiEmprestimo?: boolean | "";
  valorEmprestimoAtivo?: number | "";
  recebeViaCrefisa?: number | "";
  possuiDebitos?: boolean | "";
  valorTotalDebitos?: number | "";
}

export type BankInfo = {
  codigo: string;
  nome: string;
};

export type Consentimento = {
  status: boolean;
  mensagem: string;
  consentimentoId: string;
  linkConsentimento: string;
  consentimentoAutorizado: boolean;
  codigoBanco: string;
};

export type ConsentimentoExistente = {
  consentimentoId: string;
  codInstituicao: string;
  statusConsentimento: string;
};

type DadoConsentimento = {
  dadosConsentimentoId: string;
  consentimentoId?: string;
  codigoBanco: string;
  nomeBanco: string;
  agencia: string;
  conta: string;
  digitoConta: string;
  tipoConta: string;
};

export type Simulacao = {
  idSimulacao: string;
  idContratoRefin: string;
  codigoParceiro: number;
  tipoOperacao: number;
  codigoDataRecebimentoId: number;
  dataLiberacao: string;
  valorSolicitado: number;
  valorParcela: number;
  dataPrimeiroVencimento: string;
  quantidadeParcelas: number;
  valorCreditado: number;
};

export interface CreateSimulationsResponse {
  sucesso: boolean;
  valorLimiteTomado: number;
  mensagemLimiteTomado: string;
  matricula: string;
  digitoMatricula: string;
  renda: number;
  informacao: string;
  openFinanceObrigatorio: boolean;
  requerConsentimento?: boolean;
  dadosConsentimento?: DadoConsentimento[];
  consentimentoPendente?: boolean;
  consentimentoId?: string;
  linkConsentimento?: string;
  simulacoes: Simulacao[];
  commission: number;
  installment: number[];
  statusPortalTransparencia?:
    | "atualizado"
    | "desatualizado"
    | "nao_encontrado"
    | null;
  selectedInstallment?: number;
  banksInfos?: BankInfo[];
  consentimentos?: ConsentimentoExistente[];
  consentimento?: Consentimento;
  mensagem?: string;
}

export async function createSimulations(
  clientId: string,
  data: CreateSimulationsRequest,
  options?: StreamOptions,
) {
  return streamRequest<CreateSimulationsResponse>({
    method: "POST",
    path: `/crefisa/simulation/${clientId}`,
    body: data,
    journey: PartnerType.CREFISA,
    ...options,
  });
}
